import moment from 'moment';
import {
    Row,
    Col,
    DatePicker,
    Input,
    Select,
    Switch,
    Space,
    Typography,
} from 'antd';
import { useContext, useEffect, useState } from 'react';
import { IContext } from '../context/issues.interface';
import SelectRenderColumns from '../../SelectRenderColumns';
import { COLUMN_OPTIONS, STORAGE_COLUMNS_NAME } from '../constants';
import { IssuesContext } from '../context/issues.context';

interface IOption {
    label: string;
    value: string;
}

const { RangePicker }: any = DatePicker;
const { Search } = Input;
const { Text } = Typography;

const Filters = ({
    searchParams,
    handleDate,
    handleWorkspace,
    handleBooking,
    handleStatus,
    handleIssueId,
    handleUnRead,
    handleType,
}: Partial<IContext>) => {
    const {
        selectedColumns,
        handleSelectedColumns,
        issuesTypes,
        loading,
    } = useContext(IssuesContext);

    const {
        issueId,
        status,
        workspaceId,
        numericId,
        hasNewMessages,
        type,
    } = searchParams;

    const STATUS = [
        { label: 'PENDING', value: 'PENDING' },
        { label: 'ACTIVE', value: 'ACTIVE' },
        { label: 'SUCCESS', value: 'SUCCESS' },
        { label: 'EXPIRED', value: 'EXPIRED' },
        { label: 'REFUNDED', value: 'REFUNDED' },
    ];

    return (
        <Row justify="start" gutter={[16, 24]}>
            <Col>
                {
                    handleDate && (
                        <RangePicker
                            onChange={(date: any = []) => {
                                if (date) {
                                    const [startDate, endDate] = date;
                                    handleDate([
                                        startDate.startOf('day').toISOString(),
                                        endDate.endOf('day').toISOString(),
                                    ]);
                                } else {
                                    handleDate([]);
                                }
                            }}
                        />
                    )
                }
            </Col>
            <Col>
                <Select
                    defaultValue={status}
                    mode="multiple"
                    style={{ width: '160px' }}
                    placeholder="Status"
                    onChange={handleStatus}
                    options={STATUS}
                    maxTagCount="responsive"
                />
            </Col>
            <Col>
                <Search
                    allowClear
                    enterButton
                    style={{ width: '350px' }}
                    placeholder="Search by workspace Unique ID"
                    defaultValue={workspaceId}
                    onSearch={handleWorkspace}
                />
            </Col>
            <Col>
                <Search
                    allowClear
                    enterButton
                    style={{ width: '350px' }}
                    placeholder="Search by booking numeric Id"
                    defaultValue={numericId}
                    onSearch={handleBooking}
                />
            </Col>
            <Col>
                <Search
                    allowClear
                    enterButton
                    placeholder="Issue ID"
                    defaultValue={issueId}
                    onSearch={handleIssueId}
                />
            </Col>
            <Col>
                <Select
                    defaultValue={type}
                    style={{ width: '280px' }}
                    placeholder="Issue Type"
                    onChange={handleType}
                    loading={loading}
                    options={issuesTypes}
                    maxTagCount="responsive"
                    allowClear
                />
            </Col>
            <Col>
                <SelectRenderColumns
                    options={COLUMN_OPTIONS}
                    value={selectedColumns}
                    localStorageName={STORAGE_COLUMNS_NAME}
                    setColumns={handleSelectedColumns}
                />
            </Col>
            <Col>
                <Space size={8} align="center">
                    <Text>New Messages</Text>
                    <Switch
                        defaultChecked={hasNewMessages}
                        checkedChildren="Yes"
                        unCheckedChildren="No"
                        onChange={handleUnRead}
                    />
                </Space>
            </Col>
        </Row>
    );
};

export default Filters;
